import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout.vue';

/**
 * 其他-模块
 */
var other = {
  path: '/active',
  redirect: '/active/invite',
  component: RootLayout,
  children: [{
    path: 'invite',
    name: 'Invite',
    component: function component() {
      return import('@/views/active/invite/index');
    },
    meta: {
      title: '邀请好友'
    }
  }, {
    path: 'nodePlan',
    name: 'NodePlan',
    component: function component() {
      return import('@/views/active/nodePlan/index.vue');
    },
    meta: {
      title: '节点计划'
    }
  }, {
    path: 'nodePlan/rule',
    name: 'NodePlanRule',
    component: function component() {
      return import('@/views/active/nodePlan/rule.vue');
    },
    meta: {
      title: '节点计划规则'
    }
  }, {
    path: 'nodePlan/invite',
    name: 'NodePlanInvite',
    component: function component() {
      return import('@/views/active/nodePlan/invite.vue');
    },
    meta: {
      title: '邀请好友'
    }
  }, {
    path: 'nodePlan/friend',
    name: 'NodePlanFriend',
    component: function component() {
      return import('@/views/active/nodePlan/friend.vue');
    },
    meta: {
      title: '节点好友'
    }
  }, {
    path: 'nodePlan/rebateLink',
    name: 'NodePlanRebateLink',
    component: function component() {
      return import('@/views/active/nodePlan/rebateLink.vue');
    },
    meta: {
      title: '我的返佣链接'
    }
  }]
};
export default other;